import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { AppContext } from '../appState'
import {
   BoxContainerLighter,
   Button,
   H2,
   H3,
   Input,
   Label,
   TwoColumnContent
} from '@welcom/esg-react-components'
import { Statusbar } from '../components/Statusbar'
import { isValidSSN } from '../utils/validation'
import { InfoButtonModal } from '@welcom/esg-react-components/dist/molecules/InfoButton'

const AlignLeft = styled.div`
   text-align: left;
`
const FlexContainer = styled.div`
   display: flex;
   margin: 40px 0 20px 0;

   h3 {
      margin-bottom: 0;
      margin-right: 20px;
   }
`
const ErrorMessage = styled.div`
   color: #e75236;
   font-weight: bold;
   font-size: 12px;
`

export const Siblings = () => {
   const { store, dispatch, setDisableNext } = useContext(AppContext)
   const [allSSN, setAllSSN] = useState({}) // object with array for SNN, set with sibling index as key
   const [numberOfSiblings, setNumberOfSiblings] = useState(
      store.siblings.length
   )

   /* Validate and enable next button */
   useEffect(() => {
      let validate = true
      store.siblings.forEach(sibling => {
         if (!sibling.name || !sibling.surname || !sibling.SSN) {
            validate = false
         }
      })
      if (validate) {
         setDisableNext(false)
      } else {
         setDisableNext(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [store.siblings])

   /* Add emails from store */
   useEffect(() => {
      /* if email is set, add to email values */
      store.siblings.forEach((sibling, index) => {
         if (sibling.SSN) {
            updateSSN(store.siblings[index].SSN, index)
         }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   /* Create a new object for sibling in store.siblings */
   const updateNumberOfSiblings = siblings => {
      for (let i = 0; i <= siblings; i++) {
         if (store.siblings && store.siblings[i] === undefined) {
            dispatch({
               type: 'createSibling',
               sibling: i
            })
         }
      }
   }

   useEffect(() => {
      setNumberOfSiblings(store.siblings.length)
   }, [store.siblings])

   const updateSSN = (value, index) => {
      let valid = isValidSSN(value, true)
      valid?.valid
         ? dispatch({
              type: 'updateSibling',
              key: 'SSN',
              sibling: index,
              value: value
           })
         : dispatch({
              type: 'updateSibling',
              key: 'SSN',
              sibling: index,
              value: ''
           })

      let values = { ...allSSN }
      values[index] = { value: value, valid: valid }
      setAllSSN(values)
   }

   const renderSiblings = () => {
      let siblingsForms = []

      for (let i = 0; i < numberOfSiblings; i++) {
         const visibleNumber = i + 1
         siblingsForms.push(
            <div key={i}>
               <FlexContainer>
                  <H3>Sibling {visibleNumber}</H3>
               </FlexContainer>
               <TwoColumnContent>
                  <div>
                     <Label required={true} HtmlFor={'name' + i}>
                        First Name
                     </Label>
                     <Input
                        type={'text'}
                        id={'name' + i}
                        required
                        value={store.siblings[i].name ?? ''}
                        onChange={e => {
                           dispatch({
                              type: 'updateSibling',
                              key: 'name',
                              sibling: i,
                              value: e.target.value
                           })
                        }}
                     />
                  </div>
                  <div>
                     <Label required={true} HtmlFor={'surname' + i}>
                        Last Name
                     </Label>
                     <Input
                        type={'text'}
                        id={'surname' + i}
                        required
                        value={store.siblings[i].surname ?? ''}
                        onChange={e => {
                           dispatch({
                              type: 'updateSibling',
                              key: 'surname',
                              sibling: i,
                              value: e.target.value
                           })
                        }}
                     />
                  </div>
                  <div>
                     <Label required={true} HtmlFor={'ssn' + i}>
                        Personal number
                     </Label>
                     <InfoButtonModal>
                        <div>
                           <p>
                              <b>Enter the personal number with 12 digits.</b>
                              <br />
                              If you don’t have last 4 numbers put an x instead
                              of the number.
                           </p>

                           <p>
                              <b>For example:</b>
                              <br />
                              20200102-XXXX
                           </p>
                        </div>
                     </InfoButtonModal>
                     <Input
                        type={'text'}
                        id={'ssn' + i}
                        required
                        value={allSSN[i]?.value ?? ''}
                        pattern="^(19|20)?(\d{6}([-+]|\s)(\d{4}|x{4}|X{4}))$"
                        placeholder={'20YYMMDD-XXXX'}
                        onChange={e => {
                           updateSSN(e.target.value, i)
                        }}
                     />
                     <ErrorMessage>{allSSN[i]?.valid?.error}</ErrorMessage>
                  </div>
               </TwoColumnContent>
            </div>
         )
      }

      return siblingsForms
   }

   return (
      <AlignLeft>
         <BoxContainerLighter>
            <Statusbar currentStep={2} />
            <H2>3. Siblings</H2>
            <p>Fields marked with an * are required.</p>
            {renderSiblings()}

            <FlexContainer>
               <H3>Sibling {numberOfSiblings + 1}</H3>
               <Button
                  size={'small'}
                  label={'Add +'}
                  onClick={e => updateNumberOfSiblings(numberOfSiblings)}
               />
            </FlexContainer>
         </BoxContainerLighter>
      </AlignLeft>
   )
}
